import { jsxs as d, Fragment as F, jsx as k } from "react/jsx-runtime";
import { memo as g } from "react";
import { Slot as j } from "../../node_modules/@radix-ui/react-slot/dist/index.es.js";
import t from "../../_virtual/index.es.js";
import { css as n } from "../stitches.config.es.js";
import C from "../../icons/WtnCheckmark.es.js";
import { wtnStyles as W, wtnDecimalStyles as b, wtnMarkStyles as v } from "./Wtn.styles.es.js";
import { usePoppinsFont as A } from "../../hooks/usePoppinsFont.es.js";
function B({
  asChild: u,
  confident: h,
  className: c,
  classNames: m,
  hideMark: w,
  styles: i,
  props: o,
  children: r,
  sx: f
}) {
  A();
  const x = u ? j : "data", [D, S] = (r || 0).toFixed(2).split(".");
  return /* @__PURE__ */ d(x, { className: t(W(f && {
    css: f
  }), (i == null ? void 0 : i.root) && n(i.root)(), c, m == null ? void 0 : m.root), value: r, ...o == null ? void 0 : o.root, children: [
    r ? /* @__PURE__ */ d(F, { children: [
      D,
      ".",
      /* @__PURE__ */ k("span", { className: t(b(), m == null ? void 0 : m.decimal, (i == null ? void 0 : i.decimal) && n(i.decimal)()), ...o == null ? void 0 : o.decimal, children: S })
    ] }) : "-",
    !w && /* @__PURE__ */ k(C, { className: t(v(), m == null ? void 0 : m.mark, (i == null ? void 0 : i.mark) && n(i.mark)()), fill: h ? "#003A70" : "#D0D3DB", height: 8, width: 8, ...o == null ? void 0 : o.mark }),
    " "
  ] });
}
const I = g(B);
export {
  I as default
};
//# sourceMappingURL=Wtn.es.js.map
